import { createContext, useContext, useEffect, useState } from "react";
import { useAPI } from "../api/useAPI";

export type SimulatedPosition = {
  Tag: "CLOSE SHORT" | "CLOSE LONG" | "SHORT" | "LONG";
  Date: Date;
  Price: number;
  Coin: string;
};

export type SimulatedContextState = {
  positions: SimulatedPosition[];
};

export const initialCardsContext: SimulatedContextState = {
  positions: [],
};
const SimulatedPositionsContext = createContext(initialCardsContext);

export const useSimulatedLoginContext = () =>
  useContext(SimulatedPositionsContext);

export default function SimulatedPositionsContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [positions, setPositions] = useState<
    SimulatedContextState["positions"]
  >([]);
  const { getSimulatedPositions } = useAPI();

  useEffect(() => {
    getSimulatedPositions().then((response) => {
      if (response.success) {
        const parsedPositions = Object.entries(response.data).map(
          ([coin, positions]: [string, any]) => {
            return positions.map((position: any) => ({
              ...position,
              Date: new Date(position.Date),
              Coin: coin,
            }));
          }
        );
        setPositions(parsedPositions.flat());
      }
    });
  }, []);

  return (
    <SimulatedPositionsContext.Provider value={{ positions }}>
      {children}
    </SimulatedPositionsContext.Provider>
  );
}
